var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('detail-banner',{attrs:{"sightName":_vm.sightName,"bannerImg":_vm.bannerImg,"bannerImgs":_vm.gallaryImgs}}),_vm._v(" "),_c('detail-header'),_vm._v(" "),_c('div',{staticClass:"content"},[_c('detail-list',{attrs:{"list":_vm.list}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-075baff2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/detail/Detail.vue
// module id = null
// module chunks = 